<template>
  <div>
    <router-view/>  
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #344250;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

input,
textarea,
button,
select,
svg,
a {
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  outline: none;
}
</style>
